import * as React from 'react';

import userActivitySingleton from './UserActivitySingleton';
import { INITIAL_HEARTBEAT_COUNT, TEN_SECONDS_IN_MS } from './constants';
import { makeNetworkCall } from './lib';
import { useHeartbeatPayload } from './useHeartbeatPayload';

/**
 * Hook to initialize and run the LMS heartbeat system
 */
const useHeartbeat = () => {
  React.useEffect(() => {
    userActivitySingleton.initialize();
  }, []);

  const [heartbeatCount, setHeartbeatCount] = React.useState(INITIAL_HEARTBEAT_COUNT);

  /** Payload will change on every page navigation */
  const payload = useHeartbeatPayload();

  // Navigation side effects
  React.useEffect(() => {
    /* 
    Whenever the payload changes, this means a page nav.
    Therefore, we need to make the initial heartbeat network call AND 
    reset the heartbeat count.
    */
    makeNetworkCall({
      ...payload,
      heartbeatCount: INITIAL_HEARTBEAT_COUNT,
    });
    setHeartbeatCount(INITIAL_HEARTBEAT_COUNT);
  }, [payload]);

  // Recurring heartbeat check
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (!userActivitySingleton.anInteractionOccurredInThePastTenSeconds()) {
        return;
      }

      const updatedHb = heartbeatCount + 1;
      setHeartbeatCount(updatedHb);
      makeNetworkCall({
        ...payload,
        heartbeatCount: updatedHb,
      });
    }, TEN_SECONDS_IN_MS);

    return () => {
      window.clearInterval(interval);
    };
  }, [heartbeatCount, payload]);
};

export default useHeartbeat;
